import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GridContainer from '../global/GridContainer/GridContainer';

import NHSLOGO from '../../assets/images/national_health_service_england_logo.svg';
import AskAuntyLogoIcon from '../../assets/images/ask_aunty_logo.png';

import FeatureFlagsApi from '../../api/featureFlags';

import HomeHubItem from './components/HomeHubItem';

const Home = ({ homeHub, getHomeHub }) => {
  const navigate = useNavigate();
  const [showHomeTab, setShowHomeTab] = useState(true);
  const [showWorshipLocations, setShowWorshipLocations] = useState(true);


  useEffect(() => {
    getHomeHub()

    FeatureFlagsApi.fetchFeatureFlags()
      .then((data) => {
        setShowHomeTab(data.feature_flags.SHOW_HOME_TAB);
        setShowWorshipLocations(data.feature_flags.SHOW_WORSHIP_LOCATION);

        if (!data.feature_flags.SHOW_HOME_TAB) {
          navigate('/');
        }
      })
      .catch((e) => {});
  }, []);


  return (
    <div className="home-container">
      {showHomeTab ? (
        <GridContainer>
          <div className="home-container--upper">
            <h3 className="title m-0">Home</h3>
            <div className="home-container-header">
              <img className="home-container-header-nhs" src={NHSLOGO} alt="nhs logo" />
              <img width="286" height="240" src={AskAuntyLogoIcon} alt="logo" />
              <p className="home-container-header-title">Explore the Ask Aunty App</p>
              <p>
                Get personalised support to settle into the NHS and life in the UK with the Ask
                Aunty app.
              </p>
            </div>

            {homeHub && homeHub.map((item) => <HomeHubItem item={item} showWorshipLocations={showWorshipLocations} />)}
          </div>
        </GridContainer>
      ) : null}
    </div>
  );
};

export default Home;
